import SMImg1 from '@/assets/img/corporate-and-organization/sm_img01@2x.jpg';
import SMImg2 from '@/assets/img/corporate-and-organization/sm_img02@2x.jpg';
import SMImg2M from '@/assets/img/corporate-and-organization/sm_img02_m@2x.jpg';
import SMImg3 from '@/assets/img/corporate-and-organization/sm_img03@2x.jpg';
import SMImg3M from '@/assets/img/corporate-and-organization/sm_img03_m@2x.jpg';
import SMImg4 from '@/assets/img/corporate-and-organization/sm_img04@2x.jpg';
import SMImg4M from '@/assets/img/corporate-and-organization/sm_img04_m@2x.jpg';
import SMImg5 from '@/assets/img/corporate-and-organization/sm_img05@2x.jpg';
import SMImg6 from '@/assets/img/corporate-and-organization/sm_img06@2x.jpg';
import SMLogo from '@/assets/img/corporate-and-organization/sm_logo@2x.png';
import SMLogoM from '@/assets/img/corporate-and-organization/sm_logo_m@2x.png';
import Button from '@/components/Button';
import Container from '@/components/Container';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { navigate, PageProps } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

const Flex = styled.div`
  display: flex;

  ${breakpoint(`tablet`)} {
    flex-direction: column;
  }
`;
const ImgBox = styled.div`
  position: relative;
  width: 100%;

  .img_copyright {
    font-size: 12px;
    color: #fff;
    opacity: 0.5;
    position: absolute;
    bottom: 23px;
    left: 20px;

    &.img_copyright--gray {
      color: #2d2926;
    }

    ${breakpoint(`mobile`)} {
      bottom: 13px;
      left: 10px;
    }
  }
`;
const SectionHead = styled.section`
  background: #f8fcfe;
  padding: 96px 0 120px;

  ${breakpoint(`mobile`)} {
    padding: 72px 0 44px;

    .br_pc {
      display: none;
    }
  }

  ${Flex} {
    align-items: flex-end;
    gap: 60px;

    ${breakpoint(`mobile`)} {
      gap: 32px;
    }
  }

  ${ImgBox} {
    width: 57%;
    ${breakpoint(`tablet`)} {
      width: 100%;
    }
  }

  .company_info {
    ${breakpoint(`tablet`)} {
      width: 100%;
    }
    .company_logo img {
      width: auto;
    }

    .company_name {
      font-size: 40px;
      font-weight: 700;
      margin: 30px 0 40px;
    }

    ul {
      border-top: 1px solid #2d2926;
      padding-top: 20px;

      li {
        display: flex;
        align-items: center;
        position: relative;

        & + li {
          margin-top: 6px;
        }

        &::before {
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          border-radius: 100%;
          background: #1cabe2;
          position: absolute;
          top: 11px;
          left: 0;
          flex-shrink: 0;
        }

        .info_tit {
          font-weight: 700;
          color: #1cabe2;
          width: 102px;
          flex-shrink: 0;
          margin-right: 45px;
          padding-left: 12px;
        }
      }
    }
    ${breakpoint(`mobile`)} {
      .company_name {
        font-size: 24px;
        margin: 12px 0 20px;
      }

      ul {
        li {
          line-height: 28px;
          & + li {
            margin-top: 4px;
          }

          .info_tit {
            width: 92px;
            margin-right: 30px;
          }
        }
      }
    }
  }
`;
const SectionBody = styled.section`
  padding-top: 120px;
  p {
    margin-top: 32px;
    line-height: 32px;
  }

  .tit_small {
    margin-top: 32px;

    & + p {
      margin-top: 16px;
    }
  }

  ${breakpoint(`mobile`)} {
    padding-top: 60px;

    .br_pc {
      display: none;
    }
    p {
      font-size: 14px;
      line-height: 28px;
    }
  }

  ${Container} {
    & + ${Container} {
      margin-top: 96px;

      ${breakpoint(`mobile`)} {
        margin-top: 72px;
      }
    }
  }

  .video_wrap {
    width: 100%;
    padding-top: 56.25%;
    position: relative;
    margin-top: 32px;

    .video {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
    }
  }

  ${ImgBox} {
    margin-top: 32px;
  }

  ${Flex} {
    margin-top: 32px;
    ${ImgBox} {
      margin-top: 0;
      flex: 1;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .btn_wrap {
    margin-top: 64px;
    text-align: center;

    ${breakpoint(`mobile`)} {
      margin-top: 48px;
    }
    ${Button} {
      font-size: 16px;
    }
  }
`;

const SMentertainment: React.FC<PageProps> = ({ location }) => (
  <LayoutWithTitle
    location={location}
    title="기업·기관 사회공헌"
    description="for every child, partnerships"
  >
    <SectionHead>
      <Container>
        <Flex>
          <ImgBox>
            <img
              src={SMImg1}
              alt="신한카드-유니세프 미래세대 보호 프로젝트: 국내외 아동, 청소년 마음건강 및 디지털 교육 지원 이미지"
            />
            <div className="img_copyright">© 유니세프 한국위원회</div>
          </ImgBox>
          <div className="company_info">
            <div className="company_logo">
              <Image
                pcSrc={SMLogo}
                mobileSrc={SMLogoM}
                alt="SM entertainment 로고"
              />
            </div>
            <div className="company_name">SM엔터테인먼트</div>
            <ul>
              <li>
                <div className="info_tit">산업군</div>
                <div className="info_con">엔터테인먼트</div>
              </li>
              <li>
                <div className="info_tit">파트너십 레벨</div>
                <div className="info_con">National</div>
              </li>
              <li>
                <div className="info_tit">홈페이지</div>
                <div className="info_con">
                  <LinkSafe
                    to="https://www.smentertainment.com"
                    target="_blank"
                  >
                    https://www.smentertainment.com
                  </LinkSafe>
                </div>
              </li>
              <li>
                <div className="info_tit">지원 분야​</div>
                <div className="info_con">Education</div>
              </li>
            </ul>
          </div>
        </Flex>
      </Container>
    </SectionHead>
    <SectionBody>
      <Container>
        <Tit size="s1-5">SM엔터테인먼트는</Tit>
        <p>
          유니세프한국위원회와 2015년 11월부터 ‘SMile for U’ 캠페인을
          시작했습니다.
          <br />
          이 캠페인은 UN SDGs에 근거해 베트남 내 아동, 특히 소수민족과 장애인을
          포함한 모든 어린이가 자유롭고 공평한 양질의 교육을 받을 수 있도록
          <br className="br_pc" />
          ‘음악을 통한 성장(Growing with music)’을 목표로 추진되고 있습니다.
          <br />
          지금까지 SMile for U는 현지 음악 교육 커리큘럼을 개발하고, 전문 교사를
          양성하며, 악기와 교실 등 시설을 지원하는 등 다각도로 음악 교육 정착을
          위해 노력해왔습니다.
          <br />
          베트남 정부로부터 이 노력을 인정받아 2022년에는 교육훈련부 공교육 음악
          커리큘럼 정식 승인을 받는 성과를 이뤘습니다.
          <br />
          2023년부터는 필리핀으로도 캠페인을 확대해, 베트남·필리핀 총 20개 지역
          87,053명의 아동들이 수혜를 받았으며,
          <br className="br_pc" />
          교사, 교사의 트레이너, 양육자 및 보호자까지 역량 강화 지원을 받을 수
          있었습니다. (*2025년 상반기 누적기준)
          <br />
          앞으로도 유니세프와 SM엔터테인먼트는 음악 교육 제도화 및 지역 확대를
          위해 지속적으로 본 캠페인을 추진할 예정입니다.
        </p>
        <Flex>
          <ImgBox>
            <Image
              pcSrc={SMImg2}
              mobileSrc={SMImg2M}
              alt="음악을 통한 성장 이미지"
            />
            <div className="img_copyright">© 유니세프 한국위원회</div>
          </ImgBox>
          <ImgBox>
            <Image
              pcSrc={SMImg3}
              mobileSrc={SMImg3M}
              alt="음악을 통한 성장 이미지"
            />
            <div className="img_copyright">© 유니세프 한국위원회</div>
          </ImgBox>
          <ImgBox>
            <Image
              pcSrc={SMImg4}
              mobileSrc={SMImg4M}
              alt="음악을 통한 성장 이미지"
            />
            <div className="img_copyright img_copyright--gray">
              © 유니세프 한국위원회
            </div>
          </ImgBox>
        </Flex>
      </Container>
      <Container>
        <Tit size="s1-5">
          유니세프 한국위원회·SM엔터테인먼트 음악교육 지원사업 협약 체결 모든
          어린이가 행복한 세상 ‘SMile for U’
        </Tit>
        <div className="video_wrap">
          <iframe
            className="video"
            src="https://www.youtube.com/embed/vdc4FCt5WLQ"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </Container>
      <Container>
        <Tit size="s1-5">음악을 통한 사회 통합</Tit>
        <p>
          SMile for U 캠페인은 54개 민족으로 구성된 베트남의 특성에 맞게
          소수민족이 베트남어를 배우는 동시에 <br className="br_pc" />
          자신들의 언어로 음악을 배우는 경험 등을 제공하며 고유 언어 및 문화를
          이어갈 수 있는 교육 과정을 포함하고 있습니다.
          <br />
          베트남의 초중고 미취학 아동 청소년 비율은 평균 22% 수준이며(2022년
          베트남 교육 환경 조사 연구), 도농 격차가 두드러집니다.
          <br />
          SM엔터테인먼트와 유니세프 한국위원회, 유니세프 베트남은 함께 지역,
          민족간 차별이 없는 평등한 교육 환경 제공을 위해 노력하고 있습니다.
        </p>
        <Flex>
          <ImgBox>
            <img src={SMImg5} alt="베트남 아동이 음악 수업을 듣는 모습" />
            <div className="img_copyright">© 유니세프 한국위원회</div>
          </ImgBox>
          <ImgBox>
            <img src={SMImg6} alt="베트남 아동이 공연을 하는 모습" />
            <div className="img_copyright">© 유니세프 한국위원회</div>
          </ImgBox>
        </Flex>
        <Tit size="s3" className="tit_small">
          모두를 위한 음악실
        </Tit>
        <p>
          장애아동 및 소수민족 아동이 음악 교육 및 치료를 받을 수 있는 전용 학습
          공간으로 기존 공간을 개선하고, 다양한 악기를 구비했습니다.{' '}
          <br className="br_pc" />
          또한 장애 아동 특화 음악치료 모듈도 개발했습니다.
        </p>
        <Tit size="s3" className="tit_small">
          IERC(포용적 교육 기관)
        </Tit>
        <p>
          IERC(Inclusive Education Resource Center)는 장애아동과 비장애아동이
          더불어 통합교육을 받을 수 있는 교육기관입니다.
          <br />
          다양한 배경을 가진 유치원과 초등학교 연령대 아동들이 자유롭게 학습하고
          서로 소통하고 협력하며 사회에서 소외되지 않고 살아갈 수 있도록 하는
          것을 목표로 합니다.
          <br />
          특히 음악을 치료의 보조 도구로 활용하여 아동의 신체적, 정서적, 인지적,
          사회적 능력 향상에 도움을 주는 교육을 수행하고 있습니다.
        </p>
      </Container>
      <div className="btn_wrap">
        <Button
          className="btn"
          color="grey"
          width={256}
          onClick={() =>
            navigate(`/involve/corporate-and-organization/social-contribution`)
          }
        >
          뒤로가기
        </Button>
      </div>
    </SectionBody>
  </LayoutWithTitle>
);

export default SMentertainment;
